import Popup from "./Popup";

export default function PopupErrorUnclip({
  isOpen,
  onPrimaryClick,
  onClose,
}: {
  isOpen: boolean;
  onPrimaryClick: () => void;
  onClose: () => void;
}) {
  return (
    <Popup
      heading="エラー"
      subheading="保存済クーポンの解除に失敗しました。"
      primaryButtonLabel="戻る"
      onPrimaryClick={onPrimaryClick}
      testId="popup-error-unclip"
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}
